import { type FormControl, type FormGroupDirective, type NgForm } from '@angular/forms';
import { type ErrorStateMatcher } from '@angular/material/core';
import { searchRootFormGroup } from '../reactive-forms/search-root-form-group';

/** Error when invalid control is dirty, touched, or submitted. */
export class CustomErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    let isSubmitted = form && form.submitted;
    // Check custom implementation submit in PTFormGroup
    if (
      isSubmitted === false &&
      form !== null &&
      form.form !== null &&
      searchRootFormGroup(form.form)?.submitted() === true
    ) {
      isSubmitted = true;
    }
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
